// This file was automatically generated from print.refPanel.meds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.refPanel.meds');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.medOrderThread');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.meds.permList = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var tList16915 = opt_data.threads;
  var tListLen16915 = tList16915.length;
  for (var tIndex16915 = 0; tIndex16915 < tListLen16915; tIndex16915++) {
    var tData16915 = tList16915[tIndex16915];
    el8.template.print.refPanel.meds.threadItem(tData16915, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.meds.threadItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item">');
  el8.template.ptdata.model.medOrderThread.summary(opt_data, output);
  output.append(' (started on ', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(opt_data.startDate)) : ''), ')</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.meds.medOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item">');
  el8.template.ptdata.model.medOrder.refPanelSummary(opt_data, output);
  output.append(' (ordered on ', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : ''), ')</li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.refPanel.meds.dcMedOrderItem = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item">');
  el8.template.ptdata.model.dcMedOrder.orderSummary(opt_data, output);
  output.append(' (ordered on ', (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : ''), ')</li>');
  if (!opt_sb) return output.toString();
};
